import { TrendingFeedPost } from "components";
import FeedLayout from "layouts/files/FeedLayout";
import { TreandingPageHeader } from "ui";

const Trending = () => {
    return (
        <FeedLayout pageTitle="trending">
            <div className="moment-mark-page pb-40">
                <TreandingPageHeader />

                <div className="trending-incidents">
                    <TrendingFeedPost isIncident hashtag="demoHashtag1" />
                    <TrendingFeedPost
                        isIncident
                        hashtag="demoHashtag2"
                        text="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt error veritatis vero maxime esse sed nulla quaerat. Deleniti, porro aperiam cupiditate aliquid dolorem officia quibusdam?"
                        mediaType={3}
                    />

                    <TrendingFeedPost
                        isIncident
                        hashtag="demoHashtag3"
                        mediaType={5}
                    />
                    <TrendingFeedPost
                        isIncident
                        hashtag="demoHashtag4"
                        mediaType={9}
                    />
                </div>
            </div>
        </FeedLayout>
    );
};

export default Trending;
